import { FC } from 'react';
import { useSocketDataRefresher } from 'utils/stores';

export const GlobalSocketListener: FC = () => {
  useSocketDataRefresher();
  return null;
};
